import { timeFrameMapping } from './widget-constants';

export const wcmWidgets = [
  {
    name: 'Traffic by Data Consumption',
    dataGroup: 'wireless',
    w: 3,
    endpoint: '/statistics/topn/all',
    component: 'donutChart',
    preview: 'donutChartPreview',
    isDataRate: true,
    timeFrameOptions: [
      timeFrameMapping.last24Hours,
      timeFrameMapping.last7Days,
      timeFrameMapping.last30Days,
    ],
    groupBy: 'access points',
    groupByOptions: [
      'access points', 'clients' , 'zones', 'fingerprints', 'ssids',
    ],
    disableTimeFrameDropdown: false,
    drillDownUrl : '/m/dashboard',
  },
  {
    name: 'Number of Clients',
    dataGroup: 'wireless',
    w: 3,
    // endpoint: '/statistics/locations/clients',
    endpoint: '/statistics/topn/all',
    component: 'donutChart',
    preview: 'donutChartPreview',
    timeFrameOptions: [
      timeFrameMapping.last24Hours,
      timeFrameMapping.last7Days,
      timeFrameMapping.last30Days,
    ],
    groupBy: 'access points',
    groupByOptions: [
      'access points', 'zones', 'ssids',
    ],
    disableTimeFrameDropdown: false,
    drillDownUrl : '/m/devices/clients',
  },
  {
    name: 'Access Point Status',
    dataGroup: 'wireless',
    w: 6,
    endpoint: '/devices/inventory/aps',
    component: 'donutChart',
    preview: 'donutChartPreview',
    disableTimeFrameDropdown: true,
  },
];
